import { EntityIdListQueryApiModel } from './entityIdListQueryApiModel';
import { PeriodInterval } from './periodInterval';

export class EntityIdListPeriodQueryApiModel extends EntityIdListQueryApiModel {
  period: PeriodInterval;
}
